import { endpoint } from '../../api/http';

// Only a group's block/master reservation opens the group screen; FIT and party members open their own reservation.
export const reservationNumberHref = (row) =>
  row.ReservationGroupId && !row.IsPartyGroup && row.IsBlockReservation
    ? `${endpoint}PMS/ReservationGroupDataService/ReservationGroup?groupid=${row.ReservationGroupId}&hotelid=${row.HotelId}`
    : `${endpoint}PMS/Reservations/Index/${row.Id}?hotelid=${row.HotelId}`;
